import * as React from 'react'
import QuestionInstance from '../../../types/QuestionInstance'
import {isDesktop} from 'react-device-detect'
import {ThemeColors} from '../../../Constants'

interface Props {
    questionInstanceList: QuestionInstance[]
    currentQuestionNumber: number
    nextQuestion: () => void
}

export default function (props: Props) {
    const styles = isDesktop ? stylesDesktop : stylesMobile
    return (
        <button
            style={styles.button}
            disabled={props.currentQuestionNumber === 89}
            title={'Next'}
            onClick={props.nextQuestion}>
            Next
        </button>
    )
}

const stylesDesktop = {
    button: {
        background: ThemeColors.themePrimary,
        border: 'none',
        borderRadius: 5,
        color: 'white',
        paddingTop: '0.8vw',
        paddingBottom: '0.8vw',
        paddingLeft: '1.5vw',
        paddingRight: '1.5vw',
        marginRight: '2.4vw',
        fontSize: '1.2vw',
        fontWeight: 800,
        fontFamily: "'Ubuntu', sans-serif",
    },
}

const stylesMobile = {
    button: {
        background: ThemeColors.themePrimary,
        border: 'none',
        borderRadius: '0.6vh',
        color: 'white',
        paddingTop: '1vh',
        paddingBottom: '1vh',
        paddingLeft: '2vh',
        paddingRight: '2vh',
        marginRight: '2vh',
        fontSize: '2vh',
        fontFamily: "'Ubuntu', sans-serif",
    },
}
